import React from "react";
import { stylex } from "./stylex";
import { cssVariables } from "./css_variables";

interface TextInputProps {
  testID?: string;
  value?: string;
  name?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  numberOfLines?: number;
  placeholder?: string;
  disabled?: boolean;
  invalid?: boolean;
}

const ROW_HEIGHT = 40;

export function TextInput(props: TextInputProps) {
  const {
    testID,
    value,
    disabled,
    invalid,
    name,
    onBlur = () => {},
    onChange = () => {},
    numberOfLines = 1,
    placeholder,
  } = props;
  const [isFocused, setIsFocused] = React.useState(false);

  const height = numberOfLines * ROW_HEIGHT;

  if (numberOfLines > 1) {
    return (
      <textarea
        data-testid={testID}
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        rows={numberOfLines}
        onChange={(e) => onChange(e.currentTarget.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => {
          setIsFocused(false);
          onBlur();
        }}
        name={name}
        style={{
          ...styles(
            "root",
            isFocused && "focused",
            disabled && "disabled",
            invalid && "invalid"
          ),
          height,
        }}
      />
    );
  }

  return (
    <input
      data-testid={testID}
      value={value}
      disabled={disabled}
      placeholder={placeholder}
      onChange={(e) => onChange(e.currentTarget.value)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => {
        setIsFocused(false);
        onBlur();
      }}
      name={name}
      style={{
        ...styles(
          "root",
          isFocused && "focused",
          disabled && "disabled",
          invalid && "invalid"
        ),
        height,
      }}
    />
  );
}

const styles = stylex.create({
  root: {
    boxSizing: "border-box",
    backgroundColor: "rgba(0, 0, 0, 0)",
    border: `1px solid ${cssVariables.borderColorDark}`,
    borderRadius: 4,
    width: "100%",
    padding: 8,
    resize: "none",
    WebkitAppearance: "none",
    fontFamily: cssVariables.fontFamilyBody,
    fontSize: cssVariables.textSizeMD,
    outline: "none",
    transition: "0.2s",
  },
  disabled: {
    boxShadow: "inset 0 0 490px rgba(0, 0, 0, 0.03)",
  },
  focused: {
    border: `1px solid ${cssVariables.borderColorFocus}`,
  },
  invalid: {
    border: `1px solid ${cssVariables.borderColorDanger}`,
  },
});
